export default "__VITE_ASSET__CsRv$Jil__"